import { useContext } from "react";

import { AppConfigContext } from "../../../../core/configuration/Configuration";
import { useAuthorizedFetch } from "../../../../core/data-access/useAuthorizedFetch";
import { GetContentByBuzzIdRequest } from "./GetContentByBuzzIdRequest";
import { GetContentByBuzzIdResponse } from "./GetContentByBuzzIdResponse";

export const useCatalogueBuzzApi = () => {
    const appConfigContext = useContext(AppConfigContext);
    const { httpGet } = useAuthorizedFetch();
    const baseUrl = appConfigContext.catalogueConfig.apiUrl;

    const getContentByBuzzId = async (request: GetContentByBuzzIdRequest): Promise<GetContentByBuzzIdResponse> => {
        return httpGet<GetContentByBuzzIdResponse>(`${baseUrl}/contents/get-by-buzz-id`, request);
    };

    return {
        getContentByBuzzId
    };
};
